export default __webpack_public_path__ + "static/media/mm.6de8c6ef.webp";